/**
 * OpenLayers overlay opacity (0..1). RGB / IR / module layers share this helper.
 */

export const DEFAULT_MAP_LAYER_OPACITY = 1;

export function clampLayerOpacity(value) {
  if (value == null || value === '') {
    return DEFAULT_MAP_LAYER_OPACITY;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return DEFAULT_MAP_LAYER_OPACITY;
  }
  return Math.min(1, Math.max(0, n));
}

export function applyOlLayerOpacity(layer, opacity) {
  if (!layer || typeof layer.setOpacity !== 'function') {
    return false;
  }
  layer.setOpacity(clampLayerOpacity(opacity));
  return true;
}

export function applyOpacityToLayers(layers, opacity) {
  return (layers || []).filter(Boolean).reduce((count, layer) => {
    return count + (applyOlLayerOpacity(layer, opacity) ? 1 : 0);
  }, 0);
}
